import {
    Component,
    EventEmitter,
    Input,
    InputSignal,
    OnInit,
    Output,
    Signal,
    WritableSignal,
    computed,
    effect,
    inject,
    input,
    output,
    signal,
    untracked,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IIqSocialLinks } from '../models';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DatiqUtilsDirectiveModule } from '@dat/datiq-components-pkg/utils';
import { IqEventBusBrokerService } from '@dat/iq-event-bus';

@Component({
    selector: 'iq-social-links-help-center',
    standalone: true,
    imports: [CommonModule, MatTooltipModule, DatiqUtilsDirectiveModule],
    templateUrl: './iq-social-links-help-center.component.html',
    styleUrl: './iq-social-links-help-center.component.scss',
})
export class IqSocialLinksHelpCenterComponent implements OnInit {
    @Input()
    id: string;

    helpLinks: IIqSocialLinks[] = [
        {
            label: 'Benefits of the RFP Tool',
            url: 'https://iq.support.dat.com/1-rfp-tool-45b73e50/benefits-of-the-rfp-tool-74736fca',
            sublabel: '1 minute read',
        },
        {
            label: 'RateView Quick Start Guide for Brokers',
            url: 'https://iq.support.dat.com/3-rateview-523201e4/video-rateview-quick-start-guide-for-brokers-f1292bb8',
            sublabel: '5 minute video',
        },
        {
            label: 'Ratecast Overview',
            url: 'https://iq.support.dat.com/3-rateview-523201e4/ratecast-a1d238ab/video-ratecast-overview-07d07d1b',
            sublabel: '3 minute video',
        },
        {
            label: 'DAT IQ RateView (BETA)',
            url: 'https://iq.support.dat.com/rateview-iq-d8f11ff2/dat-iq-rateview-beta-b3dce235',
            sublabel: '3 minute read',
        },
        {
            label: 'Market Conditions Index (MCI) Feature',
            url: 'https://iq.support.dat.com/2-market-conditions-e5770320',
            sublabel: '6 minute read',
        },
    ];

    rowsTruncated: boolean[];

    private _eventBus: IqEventBusBrokerService = inject(
        IqEventBusBrokerService,
    );

    ngOnInit() {
        this.rowsTruncated = this.helpLinks.map(() => false);
    }

    onClick(url: string) {
        /**
         * This dispatches an event when the user clicks on a help center link
         *
         *
         * To listen to these events, you can use the following format in your Dashboard, Section, or Component:
         *
         * ```json
         * {
         *  "onClick": [
         *    {
         *      "name": "EVENT_NAME",
         *      "payload": {},
         *      "sourceEventRule": {
         *          "payload": [
         *            {
         *                "path": "id",
         *                "operator": "eq",
         *                "value": "COMPONENT_ID"
         *            },
         *            {
         *                "path": "componentName",
         *                "operator": "eq",
         *                "value": "IqSocialLinksHelpCenter"
         *            },
         *          ]
         *      },
         *      "rules": []
         *    },
         *   ],
         * }
         * ```
         */
        const dispatch = () =>
            this._eventBus.dispatch({
                name: 'type:click',
                payload: {
                    id: this.id,
                    componentName: 'IqSocialLinksHelpCenter',
                    url,
                },
            });

        dispatch();
    }
}
